import React from 'react';
import { PrimaryButton } from 'components/buttons/primary-button/primary.button';
import { translate, translationKeys } from 'logic/translations/translations.service';

type ButtonProps = {
  disabled: boolean;
  loading: boolean;
  onClick: () => void;
};

export const ReportOfferButton: React.FC<ButtonProps> = ({ disabled, loading, onClick }) => {
  return (
    <PrimaryButton onClick={onClick} disabled={disabled} loading={loading}>
      {translate(translationKeys.reportOffer.buttonText)}
    </PrimaryButton>
  );
};
